const WHATSAPP_LINK = 'https://wa.me/905321737544?text=Merhaba,%20Google%20reklam%C4%B1ndan%20ula%C5%9F%C4%B1yorum.%20Ak%C3%BC%20/%20yol%20yard%C4%B1m%20veya%20yedek%20par%C3%A7a%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum.';
const PHONE_LINK = 'tel:+905321737544';

export default function BatteryRoadside() {
  return (
    <section
      id="aku-yardim"
      className="relative py-20 md:py-28 overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=automotive%20battery%20close%20up%20dark%20background%20dramatic%20red%20lighting%20professional%20car%20battery%20maintenance%20cinematic%20dark%20atmosphere%20premium%20quality%20photorealistic&width=1400&height=600&seq=battery1&orientation=landscape"
          alt="Akü yol yardım"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-dark/70 via-brand-dark/60 to-brand-accent/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/60 via-transparent to-brand-dark/30" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-end justify-between gap-10 md:gap-16">
          {/* Left Content */}
          <div className="w-full md:w-3/5">
            <h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-extrabold text-white leading-tight mb-6 md:mb-8">
              <span className="block">Akünüz Bittiyse</span>
              <span className="block mt-1 md:mt-2 text-brand-accent">Vakit Kaybetmeyin</span>
            </h2>

            <p className="text-brand-muted text-base md:text-lg leading-relaxed max-w-xl mb-8 md:mb-10">
              Silivri, Gümüşyaka, Çanta, Selimpaşa, Marmaraereğlisi ve Tekirdağ yolu hattında akü takviye ve yerinde akü değişimi için hızlı iletişim kurun.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <a
                href={PHONE_LINK}
                className="flex items-center justify-center gap-3 bg-brand-accent hover:bg-brand-accentHover text-white font-bold text-base md:text-lg px-7 py-4 md:py-5 rounded-full transition-all duration-200 shadow-xl active:scale-95"
              >
                <i className="fas fa-phone"></i>
                Hemen Arayın
              </a>
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 bg-white hover:bg-gray-100 text-brand-dark font-bold text-base md:text-lg px-7 py-4 md:py-5 rounded-full transition-all duration-200 shadow-xl active:scale-95"
              >
                <i className="fab fa-whatsapp text-lg"></i>
                WhatsApp'tan Yazın
              </a>
            </div>
          </div>

          {/* Right Info */}
          <div className="w-full md:w-2/5 md:text-right">
            <div className="bg-brand-surface/80 backdrop-blur-md rounded-2xl p-6 md:p-8 border border-white/10">
              <div className="flex items-center gap-3 mb-3 md:justify-end">
                <div className="w-10 h-10 flex items-center justify-center bg-brand-accent/20 rounded-full">
                  <i className="fas fa-location-dot text-brand-accent"></i>
                </div>
                <span className="text-white font-bold text-sm">Hizmet Alanı</span>
              </div>
              <p className="text-brand-muted text-sm leading-relaxed">
                Silivri – Tekirdağ hattı ve çevre bölgelerde yerinde akü desteği ve yol yardım hizmeti.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}